var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    { staticStyle: { width: "100%" }, attrs: { data: _vm.history } },
    [
      _c("el-table-column", {
        attrs: { width: "130", prop: "new_state", label: "Current" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { width: "130", prop: "old_state", label: "Previous" },
      }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "agent", label: "Agent" } }),
      _vm._v(" "),
      _c("el-table-column", { attrs: { prop: "comment", label: "Comment" } }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { width: "230", prop: "created_at", label: "Created At" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }